import './Banner.css'

export const Banner: React.FC = () => {
	return (
		<div className='banner'>
			Kochender Rochen
		</div>
	)
}